/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { AvailabilityStatus } from './';
import {
    AvailabilityStatusFromJSON,
    AvailabilityStatusFromJSONTyped,
    AvailabilityStatusToJSON,
} from './';
import type { CommunityMetadata } from './';
import {
    CommunityMetadataFromJSON,
    CommunityMetadataFromJSONTyped,
    CommunityMetadataToJSON,
} from './';
import type { OtherProfessionalBackground } from './';
import {
    OtherProfessionalBackgroundFromJSON,
    OtherProfessionalBackgroundFromJSONTyped,
    OtherProfessionalBackgroundToJSON,
} from './';
import type { ProfessionalBackground } from './';
import {
    ProfessionalBackgroundFromJSON,
    ProfessionalBackgroundFromJSONTyped,
    ProfessionalBackgroundToJSON,
} from './';
import type { ProfileAdminLinks } from './';
import {
    ProfileAdminLinksFromJSON,
    ProfileAdminLinksFromJSONTyped,
    ProfileAdminLinksToJSON,
} from './';
import type { RatedSkill } from './';
import {
    RatedSkillFromJSON,
    RatedSkillFromJSONTyped,
    RatedSkillToJSON,
} from './';
import type { SourcingStatus } from './';
import {
    SourcingStatusFromJSON,
    SourcingStatusFromJSONTyped,
    SourcingStatusToJSON,
} from './';
import type { StringQualificationField } from './';
import {
    StringQualificationFieldFromJSON,
    StringQualificationFieldFromJSONTyped,
    StringQualificationFieldToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProfileQualificationResource
 */
export interface ProfileQualificationResource {
    /**
     * 
     * @type {string}
     * @memberof ProfileQualificationResource
     */
    profileId: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileQualificationResource
     */
    comatchLegacyNotes?: string;
    /**
     * 
     * @type {StringQualificationField}
     * @memberof ProfileQualificationResource
     */
    commentOnAvailability: StringQualificationField;
    /**
     * 
     * @type {StringQualificationField}
     * @memberof ProfileQualificationResource
     */
    commentOnDailyRate: StringQualificationField;
    /**
     * 
     * @type {StringQualificationField}
     * @memberof ProfileQualificationResource
     */
    commentOnFunctionalExpertise: StringQualificationField;
    /**
     * 
     * @type {StringQualificationField}
     * @memberof ProfileQualificationResource
     */
    commentOnIndustryExpertise: StringQualificationField;
    /**
     * 
     * @type {StringQualificationField}
     * @memberof ProfileQualificationResource
     */
    commentOnMobility: StringQualificationField;
    /**
     * 
     * @type {StringQualificationField}
     * @memberof ProfileQualificationResource
     */
    commentOnOtherExpertise: StringQualificationField;
    /**
     * 
     * @type {string}
     * @memberof ProfileQualificationResource
     */
    engagementComment: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileQualificationResource
     */
    emailAddress?: string;
    /**
     * 
     * @type {Array<RatedSkill>}
     * @memberof ProfileQualificationResource
     */
    functionalSkillRatings: Array<RatedSkill>;
    /**
     * 
     * @type {Array<RatedSkill>}
     * @memberof ProfileQualificationResource
     */
    industrySkillRatings: Array<RatedSkill>;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileQualificationResource
     */
    interestInInterim: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProfileQualificationResource
     */
    internalSeniorityLevel?: number;
    /**
     * 
     * @type {StringQualificationField}
     * @memberof ProfileQualificationResource
     */
    limitations: StringQualificationField;
    /**
     * 
     * @type {string}
     * @memberof ProfileQualificationResource
     */
    language?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileQualificationResource
     */
    noLongerAvailableDueToPermanentEmployment: boolean;
    /**
     * 
     * @type {Array<RatedSkill>}
     * @memberof ProfileQualificationResource
     */
    otherSkillRatings: Array<RatedSkill>;
    /**
     * 
     * @type {string}
     * @memberof ProfileQualificationResource
     */
    phoneNumber?: string;
    /**
     * 
     * @type {StringQualificationField}
     * @memberof ProfileQualificationResource
     */
    professionalInterests: StringQualificationField;
    /**
     * 
     * @type {Array<OtherProfessionalBackground>}
     * @memberof ProfileQualificationResource
     */
    selectedOtherProfessionalBackgrounds: Array<OtherProfessionalBackground>;
    /**
     * 
     * @type {Array<ProfessionalBackground>}
     * @memberof ProfileQualificationResource
     */
    selectedProfessionalBackgrounds: Array<ProfessionalBackground>;
    /**
     * 
     * @type {StringQualificationField}
     * @memberof ProfileQualificationResource
     */
    softSkills: StringQualificationField;
    /**
     * 
     * @type {CommunityMetadata}
     * @memberof ProfileQualificationResource
     */
    communityMetadata?: CommunityMetadata;
    /**
     * 
     * @type {AvailabilityStatus}
     * @memberof ProfileQualificationResource
     */
    availabilityStatus: AvailabilityStatus;
    /**
     * 
     * @type {SourcingStatus}
     * @memberof ProfileQualificationResource
     */
    sourcingStatus: SourcingStatus;
    /**
     * 
     * @type {string}
     * @memberof ProfileQualificationResource
     */
    currentProjectId?: string;
    /**
     * 
     * @type {ProfileAdminLinks}
     * @memberof ProfileQualificationResource
     */
    links?: ProfileAdminLinks;
}

/**
 * Check if a given object implements the ProfileQualificationResource interface.
 */
export function instanceOfProfileQualificationResource(value: object): value is ProfileQualificationResource {
    if (!('profileId' in value) || value['profileId'] === undefined) return false;
    if (!('commentOnAvailability' in value) || value['commentOnAvailability'] === undefined) return false;
    if (!('commentOnDailyRate' in value) || value['commentOnDailyRate'] === undefined) return false;
    if (!('commentOnFunctionalExpertise' in value) || value['commentOnFunctionalExpertise'] === undefined) return false;
    if (!('commentOnIndustryExpertise' in value) || value['commentOnIndustryExpertise'] === undefined) return false;
    if (!('commentOnMobility' in value) || value['commentOnMobility'] === undefined) return false;
    if (!('commentOnOtherExpertise' in value) || value['commentOnOtherExpertise'] === undefined) return false;
    if (!('engagementComment' in value) || value['engagementComment'] === undefined) return false;
    if (!('functionalSkillRatings' in value) || value['functionalSkillRatings'] === undefined) return false;
    if (!('industrySkillRatings' in value) || value['industrySkillRatings'] === undefined) return false;
    if (!('interestInInterim' in value) || value['interestInInterim'] === undefined) return false;
    if (!('limitations' in value) || value['limitations'] === undefined) return false;
    if (!('noLongerAvailableDueToPermanentEmployment' in value) || value['noLongerAvailableDueToPermanentEmployment'] === undefined) return false;
    if (!('otherSkillRatings' in value) || value['otherSkillRatings'] === undefined) return false;
    if (!('professionalInterests' in value) || value['professionalInterests'] === undefined) return false;
    if (!('selectedOtherProfessionalBackgrounds' in value) || value['selectedOtherProfessionalBackgrounds'] === undefined) return false;
    if (!('selectedProfessionalBackgrounds' in value) || value['selectedProfessionalBackgrounds'] === undefined) return false;
    if (!('softSkills' in value) || value['softSkills'] === undefined) return false;
    if (!('availabilityStatus' in value) || value['availabilityStatus'] === undefined) return false;
    if (!('sourcingStatus' in value) || value['sourcingStatus'] === undefined) return false;
    return true;
}

export function ProfileQualificationResourceFromJSON(json: any): ProfileQualificationResource {
    return ProfileQualificationResourceFromJSONTyped(json, false);
}

export function ProfileQualificationResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProfileQualificationResource {
    if (json == null) {
        return json;
    }
    return {
        
        'profileId': json['profileId'],
        'comatchLegacyNotes': json['comatchLegacyNotes'] == null ? undefined : json['comatchLegacyNotes'],
        'commentOnAvailability': StringQualificationFieldFromJSON(json['commentOnAvailability']),
        'commentOnDailyRate': StringQualificationFieldFromJSON(json['commentOnDailyRate']),
        'commentOnFunctionalExpertise': StringQualificationFieldFromJSON(json['commentOnFunctionalExpertise']),
        'commentOnIndustryExpertise': StringQualificationFieldFromJSON(json['commentOnIndustryExpertise']),
        'commentOnMobility': StringQualificationFieldFromJSON(json['commentOnMobility']),
        'commentOnOtherExpertise': StringQualificationFieldFromJSON(json['commentOnOtherExpertise']),
        'engagementComment': json['engagementComment'],
        'emailAddress': json['emailAddress'] == null ? undefined : json['emailAddress'],
        'functionalSkillRatings': ((json['functionalSkillRatings'] as Array<any>).map(RatedSkillFromJSON)),
        'industrySkillRatings': ((json['industrySkillRatings'] as Array<any>).map(RatedSkillFromJSON)),
        'interestInInterim': json['interestInInterim'],
        'internalSeniorityLevel': json['internalSeniorityLevel'] == null ? undefined : json['internalSeniorityLevel'],
        'limitations': StringQualificationFieldFromJSON(json['limitations']),
        'language': json['language'] == null ? undefined : json['language'],
        'noLongerAvailableDueToPermanentEmployment': json['noLongerAvailableDueToPermanentEmployment'],
        'otherSkillRatings': ((json['otherSkillRatings'] as Array<any>).map(RatedSkillFromJSON)),
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'professionalInterests': StringQualificationFieldFromJSON(json['professionalInterests']),
        'selectedOtherProfessionalBackgrounds': ((json['selectedOtherProfessionalBackgrounds'] as Array<any>).map(OtherProfessionalBackgroundFromJSON)),
        'selectedProfessionalBackgrounds': ((json['selectedProfessionalBackgrounds'] as Array<any>).map(ProfessionalBackgroundFromJSON)),
        'softSkills': StringQualificationFieldFromJSON(json['softSkills']),
        'communityMetadata': json['communityMetadata'] == null ? undefined : CommunityMetadataFromJSON(json['communityMetadata']),
        'availabilityStatus': AvailabilityStatusFromJSON(json['availabilityStatus']),
        'sourcingStatus': SourcingStatusFromJSON(json['sourcingStatus']),
        'currentProjectId': json['currentProjectId'] == null ? undefined : json['currentProjectId'],
        'links': json['links'] == null ? undefined : ProfileAdminLinksFromJSON(json['links']),
    };
}

export function ProfileQualificationResourceToJSON(value?: ProfileQualificationResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'profileId': value['profileId'],
        'comatchLegacyNotes': value['comatchLegacyNotes'],
        'commentOnAvailability': StringQualificationFieldToJSON(value['commentOnAvailability']),
        'commentOnDailyRate': StringQualificationFieldToJSON(value['commentOnDailyRate']),
        'commentOnFunctionalExpertise': StringQualificationFieldToJSON(value['commentOnFunctionalExpertise']),
        'commentOnIndustryExpertise': StringQualificationFieldToJSON(value['commentOnIndustryExpertise']),
        'commentOnMobility': StringQualificationFieldToJSON(value['commentOnMobility']),
        'commentOnOtherExpertise': StringQualificationFieldToJSON(value['commentOnOtherExpertise']),
        'engagementComment': value['engagementComment'],
        'emailAddress': value['emailAddress'],
        'functionalSkillRatings': ((value['functionalSkillRatings'] as Array<any>).map((v) => RatedSkillToJSON(v))),
        'industrySkillRatings': ((value['industrySkillRatings'] as Array<any>).map((v) => RatedSkillToJSON(v))),
        'interestInInterim': value['interestInInterim'],
        'internalSeniorityLevel': value['internalSeniorityLevel'],
        'limitations': StringQualificationFieldToJSON(value['limitations']),
        'language': value['language'],
        'noLongerAvailableDueToPermanentEmployment': value['noLongerAvailableDueToPermanentEmployment'],
        'otherSkillRatings': ((value['otherSkillRatings'] as Array<any>).map((v) => RatedSkillToJSON(v))),
        'phoneNumber': value['phoneNumber'],
        'professionalInterests': StringQualificationFieldToJSON(value['professionalInterests']),
        'selectedOtherProfessionalBackgrounds': ((value['selectedOtherProfessionalBackgrounds'] as Array<any>).map((v) => OtherProfessionalBackgroundToJSON(v))),
        'selectedProfessionalBackgrounds': ((value['selectedProfessionalBackgrounds'] as Array<any>).map((v) => ProfessionalBackgroundToJSON(v))),
        'softSkills': StringQualificationFieldToJSON(value['softSkills']),
        'communityMetadata': CommunityMetadataToJSON(value['communityMetadata']),
        'availabilityStatus': AvailabilityStatusToJSON(value['availabilityStatus']),
        'sourcingStatus': SourcingStatusToJSON(value['sourcingStatus']),
        'currentProjectId': value['currentProjectId'],
        'links': ProfileAdminLinksToJSON(value['links']),
    };
}

